import { useContext } from 'react';
import { ChatContext, type ChatContextValue } from '@/chat/chatContext';

/** Доступ к состоянию чата (статус, комнаты, непрочитанное, matrix-клиент). Внутри ChatProvider. */
export function useChat(): ChatContextValue {
  const ctx = useContext(ChatContext);
  if (!ctx) {
    throw new Error('useChat must be used within ChatProvider');
  }
  return ctx;
}
